import { useState, useEffect, useContext } from "react";
import {
  Button,
  Col,
  Input,
  Row,
} from "antd";
import DeleteModal from "../../components/DeleteModal";
import { Severty, ShowToast } from "../../helper/toast";
import { AuthContext } from "../../context/AuthContext";
import { useNavigate, useLocation } from "react-router";
import useRequest from "../../hooks/useRequest";
const Search = Input.Search;
const toggler = [
  <svg
    width="28"
    height="28"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    key={0}
  >
    <path d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"></path>
  </svg>,
];
function Header({ onPress, setToggle }) {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const search = queryParams.get("search");
  const { logout } = useContext(AuthContext);
  const [searchText, setSearchText] = useState(search ?? "");
  const [isLogoutModalVisible, setIsLogoutModalVisible] = useState(false);
  const [totalData, SetTotalData] = useState(0);
  const { request } = useRequest()
  const navigate = useNavigate();
  useEffect(() => {
    setSearchText(search ?? "");
  }, [search]);

  const handleGlobalSearchSubmit = (value) => {
    const v = (value ?? "").trim();
    if (v) {
      navigate(`/search-data?search=${encodeURIComponent(v)}`);
    }
  };
  useEffect(() => {
    if (!isOpen) return document.body.classList.remove("edit-dropdown");
    document.body.classList.add("edit-dropdown");

    return () => {
      document.body.classList.remove("edit-dropdown");
    };
  }, [isOpen]);

  useEffect(() => {
    request({
      url: `/admin/downtown/total-count`,
      method: "GET",
      onSuccess: (data) => {
        console.log(data.data, "data.data");
        SetTotalData(data.data);
      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR);
      },
    });
  }, [])


  return (
    <>
      <Row className="align-items-center">
        <Col span={24} xs={14} md={6}>
          <div className="toggale-headr">
            <div className="">
              <Button
                type="link"
                className="sidebar-toggler ps-0 d-none d-lg-block"
                onClick={() => setToggle()}
              >
                {toggler}
              </Button>
            </div>
            <div className="tabLogo ">
              {/* <img className="w-100" src={Logo} /> */}
              <a href="/">
                <h4>Data Solutions</h4>
              </a>
            </div>
          </div>
        </Col>
        <Col span={24} xs={10} md={18} className="header-control">
          <Button
            type="link"
            className="sidebar-toggler"
            onClick={() => onPress()}
          >
            {toggler}
          </Button>
          <Button>Total Record :{totalData > 0 ? totalData : 0}</Button>
          <Search
            allowClear
            placeholder="Global Search"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            onSearch={handleGlobalSearchSubmit}
          />


        </Col>
      </Row>
      {isLogoutModalVisible && (
        <DeleteModal
          title={"Logout"}
          subtitle={`Are you sure you want to logout?`}
          show={isLogoutModalVisible}
          hide={() => {
            setIsLogoutModalVisible(false);
          }}
          onOk={() => {
            ShowToast("Logout Successfully!", Severty.SUCCESS);
            logout();
          }}
        />
      )}
    </>
  );
}

export default Header;
